import { entityTypeOptions } from '../../../shared/constants/user-info/ENTITY_TYPES';
import { getOptionsByValues } from '../../../shared/utils/arrayUtils';

export const availableEntityTypeOptions = getOptionsByValues(entityTypeOptions, [
  'GYM',
  'CHIROPRACTOR',
  'TRAINER',
  'MED_SPA',
  'NUTRITION_STORE',
  'OTHER',
]);
